/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import Markdown from '../markdown-render';
import {
  Container,
  LinkImagesContainer,
  Header,
  LinkContainer,
  ImageContainer,
} from './link-image-list-css';

const LinkImageList = ({ intro, imageLinks }) => (
  <Container>
    <Header>
      <Markdown source={intro} />
    </Header>
    <LinkImagesContainer>
      {imageLinks.map(({ image, text, url, isIcon }) => {
        return (
          <LinkContainer key={url} to={url}>
            <ImageContainer isIcon={isIcon}>
              <img src={image.src} alt={image.alt} />
            </ImageContainer>
            <span key={url}>
              {text}
            </span>
          </LinkContainer>
        );
      })}
    </LinkImagesContainer>
  </Container>
);

LinkImageList.propTypes = {
  intro: PropTypes.string.isRequired,
  imageLinks: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        src: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      }).isRequired,
      isIcon: PropTypes.bool.isRequired,
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default LinkImageList;
